// extracted by mini-css-extract-plugin
module.exports = {"block":"EmptyProgressBlock_block__3lEi0","bar":"EmptyProgressBlock_bar__29ifi"};